<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import Banner from '@/ui/Banner.vue'
import ThreeCanvas from '@/ui/three/ThreeCanvas.vue'
import { scenes } from '@/ui/three/scenes'

const { t } = useI18n()
</script>

<template>
  <div class="grid max-w-[640px] gap-2 pt-2">
    <ThreeCanvas :scene="scenes.shapes" :options="{ count: 3 }" class="h-36 w-full" />
    <Banner tone="warning">{{ t('shell.moduleOff') }}</Banner>
  </div>
</template>
